import React from 'react';
import './_modalMessage.scss';

type ModalMessageProps = { show: boolean };

const ModalMessage: React.FC<ModalMessageProps> = (props) => {
  return <div className={`modal ${props.show ? 'show' : ''}`}>Successful!</div>;
};

export default ModalMessage;
